//mui component
import React ,{ useEffect, useState } from "react";
import styled from "@emotion/styled";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
//icon
import Logout from "@mui/icons-material/Logout";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import InfoIcon from "@mui/icons-material/Info";
//slice
import { logout } from "../../redux/features/authSlice";
import { clearCart } from "../DonationView/slice";
import { resetDashBoard , fetchUnreadCount, fetchUnread,fetchAllNotifications , markasallread} from "../DashBoardView/slice";
//redux
import { useDispatch, useSelector } from "react-redux";

//router
import { useNavigate } from "react-router-dom";
//styles
import {
  containerBoxStyles,
  buttonStyles,
  buttonBoxStyles,
  headerButtonStyles,
  badgeColor,
} from "./style";
import { Avatar, Badge, Tooltip } from "@mui/material";
import {
  ComponentType,
  EntityType,
  RegistrationStatus,
  UserType,
} from "../../common/enum";
import ProfileSelector from "../../sections/auth/ProfileSelector";
import MessageDropdown from "./MessageDropdown";
import MessagePanel from "../MessagePanel";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  query,
  where,
  getCountFromServer,
  collection as firebaseCollection,
  getDocs,
  onSnapshot,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../firebase";
import NotificationDropdown from "./NotificationDropdown";
import NotificationDropdownSignalIR from "./NotificationDropdownSignalIR";
import { useSnackbar } from "notistack";
import NotificationPanel from "../NotificationPanel";
import NotificationPanelSignalIR from "../NotificationPanel/NotificationPanelSignalIR";
import MobileDropdown2 from "./Mobile2Dropdown";
import MobilePanel from "../MobilePanel/MobilePanel";
import * as signalR from "@microsoft/signalr";
import { removeFromIndexedDB } from "../../storage/profileStorage";
import { HubConnectionBuilder, LogLevel, HttpTransportType, JsonHubProtocol } from '@microsoft/signalr';
const profileLogged = [
  {
    title: "profileDonor",
    icon: "/static/register/donor.png",
    value: EntityType.donor,
    width: 30,
    height: 27,
  },
  {
    title: "profileDistributor",
    icon: "/static/register/donorReciever.png",
    value: EntityType.distributor,
    width: 27,
    height: 27,
  },
];

const Header = ({ t }) => {
  const theme = useTheme();
  const matchesDown = useMediaQuery(theme.breakpoints.down("md"));
  const matchesUp = useMediaQuery(theme.breakpoints.up("md"));
  const [open, setOpen] = React.useState(false);
  const [anchorMessageEl, setAnchorMessageEl] = React.useState(null);
  const [anchorNotificationEl, setAnchorNotificationEl] = React.useState(null);
  const [anchorNotificationElSignalIR, setAnchorNotificationElSignalIR] = React.useState(null);
  const [drawerState, setDrawerState] = React.useState(false);
  const [anchorMobileEl, setAnchorMobileEl] = React.useState(null);
  const [forceUpdate, setForceUpdate] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [drawerNotificationState, setNotificationDrawerState] =
    React.useState(false);
    const [drawerMobileState, setMobileDrawerState] =
    React.useState(false);

  const toggleDrawer = (value) => {
    setDrawerState(value);
  };

  const toggleNotificationDrawer = (value) => {
    setNotificationDrawerState(value);
  };
  
  const toggleMobileDrawer= (value) => {
    setMobileDrawerState(value);
  };
  const handleMessageClick = (event) => {
    setAnchorMessageEl(event.currentTarget);
  };

  const handleNotificationClick = (event) => {
    setAnchorNotificationEl(event.currentTarget);
  };
  const handleNotificationClickSignalIR = (event) => {
    setAnchorNotificationElSignalIR(event.currentTarget);
  };
  const handleMobileClick = (event) => {
    setAnchorMobileEl(event.currentTarget);
  };

  const setMessageMenu = React.useCallback((value) => {
    setAnchorMessageEl(value);
  }, []);

  const setNotificationMenu = React.useCallback((value) => {
    setAnchorNotificationEl(value);
  }, []);
  const setNotificationMenuSignalIR = React.useCallback((value) => {
    setAnchorNotificationElSignalIR(value);
  }, []);
  const setMobileMenu = React.useCallback((value) => {
    setAnchorMobileEl(value);
  }, []);

  const {
    auth,
    dashboardInfo: { entityProfileSelect },
  } = useSelector((state) => state);
  const { status } = auth.user || {};
  const { entity, userType, userId } = auth.profile || {};
  const [messageUserCount, setMessageUserCount] = React.useState(0);
  const [notificationUserCount, setNotificationUserCount] = React.useState(0);
  const [messsageUnreadCount, setMessageUnReadCount] = React.useState(0);

  // teste notificações count com signalir
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [allNotifications, setReceiveAllNotifications] = useState([]);
  const [allNotificacoesNotRead, setReceiveAllNotificacoesNotRead] = useState([]);

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
     .withUrl("https://app.tomaladaca.gov.pt/API/NotificationHub")
    //.withUrl(" http://57.153.83.127:8080/API/API/NotificationHub")
    //.withUrl("https://localhost:44361/api/NotificationHub")
   
    .configureLogging(signalR.LogLevel.Debug)
    .withAutomaticReconnect()
    .withHubProtocol(new signalR.JsonHubProtocol())
    .configureLogging(signalR.LogLevel.None)
    .build();
        var entityId = entity.entityId;
        connection.qs = { entityId: entityId };
    connection.onclose((error) => {
        console.error("SignalR Connection Closed:", error);
    });
    connection.start().then(() => {
        console.log("SignalR Connected");
       // console.log("Connection ID:", connection.connectionId);

        connection.on("ReceiveNotification", (notification) => {
            setNotifications((prevNotifications) => [...prevNotifications, notification]);
           // console.log(notifications)
            if(auth.profile.entityPreference.isNotificationPlatform == true && notification.entityId ==  entity.entityId){
                enqueueSnackbar({
                  message: "Tem uma nova notificação",
                  variant: "success",
                });
            }
        });

        connection.on("UpdateUnreadCount", (count) => {
            
            //console.log(unreadCount)
        });

        connection.on("ReceiveAllNotifications", (ReceiveAllNotifications) => {
          if(ReceiveAllNotifications.filter(w=> w.entitySenderDetails.entityId == entityId).length > 0){
            setReceiveAllNotifications(ReceiveAllNotifications.filter(w=> w.entitySenderDetails.entityId == entityId));
            if(ReceiveAllNotifications.filter(w=> w.entitySenderDetails.isRead == false && w.entitySenderDetails.entityId == entityId).length > 3){
              var recebidasNãolidas = ReceiveAllNotifications.filter(w=> w.entitySenderDetails.isRead == false && w.entitySenderDetails.entityId == entityId)
              setReceiveAllNotificacoesNotRead(recebidasNãolidas.slice(0, 3))
            }else {
              setReceiveAllNotificacoesNotRead(ReceiveAllNotifications.filter(w=> w.entitySenderDetails.isRead == false && w.entitySenderDetails.entityId == entityId));
            }
            setUnreadCount(ReceiveAllNotifications.filter(w=> w.entitySenderDetails.isRead == false && w.entitySenderDetails.entityId == entityId).length);
            //console.log(ReceiveAllNotifications)
          }else{
            getNotificationsServer();
          }
          
      });

       
    })
    .catch((error) => 
      console.error("Error connecting to SignalR:", error)
    );

    var entityId = entity.entityId;
    dispatch(fetchUnreadCount(entityId))
    .unwrap()
    .then((res) => {
      setUnreadCount(res.data);
    })
    .catch((error) => {
      //console.log(error);
    });
    dispatch(fetchUnread(entityId))
    .unwrap()
    .then((res) => {
      if(res.data.length > 3){
        setReceiveAllNotificacoesNotRead(res.data.slice(0, 3))
      }else{
        setReceiveAllNotificacoesNotRead(res.data)
      };
    })
    .catch((error) => {
      //console.log(error);
    });
    dispatch(fetchAllNotifications(entityId))
    .unwrap()
    .then((res) => {
      setReceiveAllNotifications(res.data);
    })
    .catch((error) => {
      //console.log(error);
    });

    return () => {
        connection.stop();
    };
},[]);


  // end teste notificações count com signalir

  const SearchBox = styled(TextField)(({ theme }) => ({
    fieldset: {
      borderRadius: "50px",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  }));

  const handleProfile = React.useCallback(() => {
    setOpen(true);
  }, []);

  const selectedProfile = React.useMemo(
   
    () => profileLogged.find((item) => item.value ===  JSON.parse(localStorage.getItem("entityProfileSelect"))),
    [entityProfileSelect]
  );

  React.useEffect(() => {
    const getMessageUserCount = () => {
      const q = query(
        collectionGroup(db, "messages"),
        where("isRead", "==", false),
        where("recevierId", "==", userId)
      );
      const unsub = onSnapshot(q, (querySnapshot) => {
        setMessageUserCount(querySnapshot.size);
      });
      return () => {
        unsub();
      };
    };
    const getNotificationCount = () => {
      const q = query(
        firebaseCollection(db, "notifications"),
        where("isRead", "==", false),
        where("donorUserId", "==", userId)
      );
      const unsub = onSnapshot(q, (querySnapshot) => {
        setNotificationUserCount(querySnapshot.size);
      });
      return () => {
        unsub();
      };
    };
    getNotificationCount();
    getMessageUserCount();
  }, []);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    dispatch(clearCart());
    dispatch(resetDashBoard());
    // localStorage.removeItem("userData");
    // localStorage.removeItem("entityProfile");
    removeFromIndexedDB("profiles", "entityProfile");
    removeFromIndexedDB("userData", "userData");
    removeFromIndexedDB("entityProfileSelect", "entityProfileSelect");
    navigate("/");
  };


const getNotificationsServer = () => {
    var entityId = entity.entityId;
    dispatch(fetchUnreadCount(entityId))
    .unwrap()
    .then((res) => {
      setUnreadCount(res.data);
    })
    .catch((error) => {
      //console.log(error);
    });
    dispatch(fetchUnread(entityId))
    .unwrap()
    .then((res) => {
      if(res.data.length > 3){
        setReceiveAllNotificacoesNotRead(res.data.slice(0, 3))
      }else{
        setReceiveAllNotificacoesNotRead(res.data)
      };
    })
    .catch((error) => {
      //console.log(error);
    });
    dispatch(fetchAllNotifications(entityId))
    .unwrap()
    .then((res) => {
      setReceiveAllNotifications(res.data);
    })
    .catch((error) => {
      //console.log(error);
    });

  };


  // const handleMarkAllAsRead = React.useCallback(() => {
  //   dispatch(markasallread(userId));
    
  //   const updatedNotifications = allNotifications.notifications.map((n) => ({ ...n, read: true }));
  //   setReceiveAllNotifications(updatedNotifications);
    
  //   setUnreadCount(0);
  // }, [dispatch, allNotifications]);

  const handleMarkAllAsRead = React.useCallback(() => {
    dispatch(markasallread(userId))
      .unwrap()
      .then(() => {
        const updatedNotifications = allNotifications.notifications.map((n) => ({
          ...n,
          isRead: true,
        }));
        setReceiveAllNotifications(updatedNotifications);
        setReceiveAllNotificacoesNotRead([]);
        setUnreadCount(0);
        setForceUpdate((prev) => !prev); // Força a atualização do componente
      })
      .catch((error) => {
        console.error("Erro ao marcar como lidas:", error);
      });
  }, [dispatch, allNotifications, userId]);

  useEffect(() => {
    // Lógica para carregar notificações quando o componente for montado
    // Ou quando o `forceUpdate` for alterado
    const fetchNotifications = async () => {
      try {
        const entityId = entity.entityId;
        const unreadCountResult = await dispatch(fetchUnreadCount(entityId)).unwrap();
        setUnreadCount(unreadCountResult.data);

        const allNotificationsResult = await dispatch(fetchAllNotifications(entityId)).unwrap();
        setReceiveAllNotifications(allNotificationsResult.data);
      } catch (error) {
        console.error("Erro ao buscar notificações:", error);
      }
    };

    fetchNotifications();
  }, [dispatch, forceUpdate]); // Atualiza sempre que forceUpdate muda

  return (
    <Box sx={containerBoxStyles}>
      {matchesDown && (
        <Button sx={buttonStyles}>
          <MenuRoundedIcon sx={{visibility: "hidden"}} />
        </Button>
      )}
      <Box>
        <img src="/static/logo.png" alt="" />
      </Box>
      <Box sx={buttonBoxStyles}>
        {(status === RegistrationStatus.inActive ||
          status === RegistrationStatus.inAtivo ||
          status === RegistrationStatus.revoked) && (
          <Box
            sx={{
              // width: 1,
              // border: `1px solid #EE9500`,
              backgroundColor: `#FFE2E2`,
              display: "flex",
              alignItems: "center",
              borderRadius: 1.5,
              p: 1,
            }}
          >
            <InfoIcon
              sx={{
                backgroundColor: `#DC2600`,
                color: "white",
                width: 32,
                height: 32,
                padding: 0.5,
                borderRadius: "10px",
              }}
            />
            <Typography variant="body2" fontWeight={600} mx={2}>
              {t("accountDisabled")}
            </Typography>
          </Box>
        )}
        {entity?.entityType === EntityType.donorDistributor &&
          userType !== UserType.gppAdmin && (
            <Tooltip title={t(selectedProfile?.title)}>
              <Button
                sx={buttonStyles}
                startIcon={
                  <Avatar
                    src={selectedProfile?.icon}
                    variant="square"
                    sx={{
                      width: selectedProfile?.width,
                      height: selectedProfile?.height,
                    }}
                  />
                }
                onClick={handleProfile}
              />
            </Tooltip>
          )}
       {matchesDown &&( 
        <Button sx={headerButtonStyles} onClick={handleMobileClick}>
              <MoreVertIcon
                sx={{ color: "black", width: "18px", height: "18px" }}
              />
          </Button>)
          
        }
        {matchesUp && (entity.isGroupEntity && entity.isParentEntity ? null : (
           <Tooltip title={"Mensagens"}>
              <Button sx={headerButtonStyles} onClick={handleMessageClick}>
                <Badge badgeContent={messageUserCount} sx={badgeColor} max={99}>
                  <ChatOutlinedIcon
                    sx={{ color: "black", width: "18px", height: "18px" }}
                  />
                </Badge>
              </Button>
           </Tooltip>
        ))}
         {/* {matchesUp && (<Button sx={headerButtonStyles} onClick={handleNotificationClick}>
          <Badge badgeContent={notificationUserCount} sx={badgeColor} max={99}>
            <NotificationsNoneOutlinedIcon
              sx={{ color: "black", width: "18px", height: "18px" }}
            />
          </Badge>
        </Button>)} */}
        {/* teste notificações signalIr */}
        {matchesUp && (
          <Tooltip title={"Notificações"}>
            <Button sx={headerButtonStyles} onClick={handleNotificationClickSignalIR}>
            <Badge badgeContent={unreadCount} sx={badgeColor} max={99}>
              <NotificationsNoneOutlinedIcon
                sx={{ color: "black", width: "18px", height: "18px" }}
              />
            </Badge>
          </Button>
          </Tooltip>
        )}
        {matchesUp && (
          <Tooltip title={"Sair"}>
            <Button
              sx={headerButtonStyles}
              onClick={(e) => handleLogout(e)}
              aria-label="Logout"
            >
              <Logout sx={{ color: "black", width: "18px", height: "18px" }} />
            </Button>
          </Tooltip>
         
        )}
      </Box>

      <ProfileSelector
        open={open}
        setOpen={setOpen}
        component={ComponentType.HEADER}
        t={t}
      />
      <MessageDropdown
        anchorEl={anchorMessageEl}
        messsageUnreadCount={messageUserCount}
        setMessageMenu={setMessageMenu}
        setOpenMessagePanel={toggleDrawer}
        t={t}
      />
      {/* <NotificationDropdown
        anchorEl={anchorNotificationEl}
        notificationUnreadCount={notificationUserCount}
        setNotificationMenu={setNotificationMenu}
        setOpenNotificationPanel={toggleNotificationDrawer}
        t={t}
      /> */}
      <NotificationDropdownSignalIR
        anchorEl={anchorNotificationElSignalIR}
        notificationUnreadCount={unreadCount}
        setNotificationMenu={setNotificationMenuSignalIR}
        setOpenNotificationPanel={toggleNotificationDrawer}
        t={t}
        allNotifications = {allNotifications}
        allNotificacoesNotRead = {allNotificacoesNotRead}
        onMarkAllAsRead={handleMarkAllAsRead}
      />
      <NotificationPanelSignalIR
        drawerState={drawerNotificationState}
        setMessageUnReadCount={setUnreadCount}
        toggleDrawer={toggleNotificationDrawer}
        t={t}
        allNotifications = {allNotifications}
      />
    <MobileDropdown2
        anchorEl={anchorMobileEl}
        //notificationUnreadCount={notificationUserCount}
        setMobileMenu={setMobileMenu}
        setMobileDrawerState={toggleMobileDrawer}
        setNotificationMenu={setNotificationMenu}
        setOpenNotificationPanel={toggleNotificationDrawer}
        setOpenMessagePanel={toggleDrawer}
        t={t}
      />
      <MessagePanel
        drawerState={drawerState}
        setMessageUnReadCount={setMessageUnReadCount}
        toggleDrawer={toggleDrawer}
        t={t}
      />
      {/* <NotificationPanel
        drawerState={drawerNotificationState}
        setMessageUnReadCount={setNotificationUserCount}
        toggleDrawer={toggleNotificationDrawer}
        t={t}
      /> */}
      
      <MobilePanel
        drawerState={drawerMobileState}
        //setMessageUnReadCount={setMobileUserCount}
        toggleDrawer={toggleMobileDrawer}
        t={t}
      />
    </Box>
  );
};

export default Header;
